export default "__VITE_ASSET__BMsVOfLv__"